import axios from 'axios';
import { toast } from 'react-toastify';

export const baseURL = process.env.REACT_APP_API_URL;
export const baseOrigin = process.env.REACT_APP_API_ORIGIN;
export const TOKEN_KEY = 'bitsweep-token';

const responseCallback = (res) => {
  if (res.status === 200) return res;
  return Promise.reject(
    res.response?.data?.error || res.response?.data.message || res.message || 'Something Went Wrong',
  );
};

export const getSECURE_API = () => {
  const SECURE_API = axios.create({ baseURL });

  SECURE_API.interceptors.response.use((req) => req, responseCallback);
  // To help our auth middleware
  SECURE_API.interceptors.request.use((req) => {
    let token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  });

  return SECURE_API;
};

export const handleCatch = (err) => {
  toast.error(err.response?.data?.message || err.message || 'Something Went Wrong');
};

export const sendFormDataRequest = (url, method = 'POST', data, file = '', successCallback) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value);
  }

  if (!data[file]) formData.delete(file);

  return fetch(`${baseURL}${url}`, {
    body: formData,
    method,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
    },
  }).then(async (res) => {
    if (res.ok) {
      successCallback();
      return await res.json();
    } else {
      return Promise.reject(await res.json());
    }
    // callBack?.();
  });
};

export const API = axios.create({ baseURL });
API.interceptors.response.use((req) => req, responseCallback);
